import { Background } from "../../../components/common";
import AdminNavbar from "../../../components/layouts/AdminNavbar";
import PageTitle from "../../../components/common/PageTitle";
import { CenteredLayout } from "../../../components/layouts";
import { Body1, Button, Divider } from "@fluentui/react-components";
import { Card } from "@fluentui/react-card";
import styles from "../../../components/layouts/EmplyeesListStyles";
import PreferencesSidebarMenu from "./PreferencesSidebarMenu";
import { useContext, useState } from "react";
import PreferencesContent from "./PreferencesContent";
import { PreferenceSection, userRoleEnum } from "../../../utils/enums";
import UserContext from "../../AppRouter/UserContext";

const PreferencesLayout = () => {
  const [selectedSection, setSelectedSection] = useState(
    PreferenceSection.Notifications
  );
  const isPhoneScreen = () => window.matchMedia("(max-width: 966px)").matches;
  const { userData } = useContext(UserContext);

  const EmployeeMenuItemsArray = [
    { id: PreferenceSection.Notifications, label: "Konfiguracja powiadomień" },
  ] as const;

  const AdminMenuItemsArray = [
    { id: PreferenceSection.Notifications, label: "Konfiguracja powiadomień" },
    { id: PreferenceSection.WorkingHours, label: "Godziny robocze" },
  ] as const;

  const goBack = () => {
    window.history.back();
  };

  return (
    <>
      <Background />
      <AdminNavbar />
      <CenteredLayout>
        <PageTitle title="Preferencje" />
        <div className="table-container">
          <Card style={styles.tableContainer}>
            <Body1>
              <Button
                appearance="primary"
                onClick={goBack}
                style={{
                  ...styles.buttonBack,
                  position: "absolute",
                  right: "1rem",
                  top: "1rem",
                }}
              >
                Powrót
              </Button>
              <div
                style={{
                  display: "flex",
                  flexDirection: isPhoneScreen() ? "column" : "row",
                  gap: isPhoneScreen() ? "1rem" : "2rem",
                  minHeight: isPhoneScreen() ? "auto" : "350px",
                }}
              >
                <PreferencesSidebarMenu
                  selectedSection={selectedSection}
                  setSelectedSection={setSelectedSection}
                  menuItems={
                    userData.data.baseRole === userRoleEnum.Admin
                      ? AdminMenuItemsArray
                      : EmployeeMenuItemsArray
                  }
                />
                {isPhoneScreen() && <Divider />}
                <div
                  style={{
                    flex: 1,
                    width: isPhoneScreen() ? "100%" : "auto",
                    marginTop: isPhoneScreen() ? "1rem" : 0,
                  }}
                >
                  <PreferencesContent selectedSection={selectedSection} />
                </div>
              </div>
            </Body1>
          </Card>
        </div>
      </CenteredLayout>
    </>
  );
};

export default PreferencesLayout;
